import { CommandAction } from "src/app/abstract/command/command-action.service";
import { WidgetsFieldModel } from "src/app/models/widgets/widgets-field.model";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";
import { Injectable } from "@angular/core";
import { WidgetsService } from "../widgets/widgets.service";
import { WidgetsMetadataService } from "../widgets/widgets-metadata.service";
import { Logger } from "src/app/core/logger";

@Injectable()
export class CommandFieldService extends CommandAction {
    constructor(
        private widgetsService: WidgetsService,    
        private widgetsMetadataService: WidgetsMetadataService,
        private logger:Logger) {
        super();
    }

    public execute(parent:WidgetsAbstract, widget: WidgetsAbstract): WidgetsFieldModel {
        const newWidget = new WidgetsFieldModel();
        newWidget.parentId =  parent.id;
        newWidget.key = this.widgetsService.getNextKey(newWidget.type);
        this.widgetsService.setLayoutTouched();
        return newWidget;        
    }
}
